import { ClaimActivitesResponse } from "../../../queries/types";

export const claimRewardsActivityModelCreator = (
  response: ClaimActivitesResponse,
): ClaimActivitesResponse => response;
